import { render, staticRenderFns } from "./MessageLogsList.vue?vue&type=template&id=46b980f6&scoped=true"
import script from "./MessageLogsList.vue?vue&type=script&lang=js"
export * from "./MessageLogsList.vue?vue&type=script&lang=js"
import style0 from "./MessageLogsList.vue?vue&type=style&index=0&id=46b980f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b980f6",
  null
  
)

export default component.exports